import { render } from "./RentalsTab.vue?vue&type=template&id=daec2fb2"
import script from "./RentalsTab.vue?vue&type=script&lang=js"
export * from "./RentalsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Products/RentalsTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "daec2fb2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('daec2fb2', __exports__)) {
    api.reload('daec2fb2', __exports__)
  }
  
  module.hot.accept("./RentalsTab.vue?vue&type=template&id=daec2fb2", () => {
    api.rerender('daec2fb2', render)
  })

}


export default __exports__